const React = require('react');


const FormModal = ({ language, closeModal, title, children }) => {
    return <div className="modal active" id="modal-id">
        <a href="#" onClick={closeModal} className="modal-overlay" aria-label="Close"/>
        <div className="modal-container">
            <div className="modal-header">
                <a href="#" onClick={closeModal} className="btn btn-clear float-right" aria-label="Close"/>
                <div className="modal-title h5">{title}</div>
            </div>
            <div className="modal-body">
                {children}
            </div>
        </div>
    </div>;
};

module.exports = FormModal;